import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Toolbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  linear_content_style,
  linear_h,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import Label from "../../../libs/rhf-mui/ui/Label";
import AppMenuButton from "../../components/AppMenuButton";
import TabPage from "../../components/TabPage";
import { sx_icon_button } from "../../components/UIHelper";
import { R } from "../../R";
import MoreIcon from "@mui/icons-material/MoreVert";
import AppBarTabs from "../../components/AppBarTabs";
import UcAnsList from "./UcAnsList";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { UniAnswer } from "../../dao/UniAnswer";
import { Toast } from "../../../libs/app-core/Toast";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { ExportManager, new_ErrorAlert } from "../../export_spwk/ExportManager";
import { UniForm } from "../../dao/UniForm";
import { sth_log } from "./SpwkToHisHelper";
import Uc快取樹狀圖 from "./Uc快取樹狀圖";
import { ExportBundle } from "../../export_spwk/ExportBundle";
import { FinishStatus, SpwkToHisInfo } from "./SpwkToHisInfo";
import UcSpwkMetaTableView from "./UcSpwkMetaTableView";
import UcGovRowView from "./UcGovRowView";
import UcHisBasicView from "./UcHisBasicView";
import UcHisRowView from "./UcHisRowView";
import UcHisDtoView from "./UcHisDtoView";
import UcSpwkPills from "./UcSpwkPills";
import { UniFunc } from "../../dao/UniFunc";
import { UniFuncDAO } from "../../dao/UniFuncDAO";
import { ROUTE_his_manager, ROUTE_spwk_to_his_rule } from "../../Routes";
import {
  HisDtoManager,
  HisDtoResult,
} from "../../export_spwk/HisDtoManager/HisDtoManager";
import HelpIcon from "@mui/icons-material/Help";
import { useLocation } from "react-router-dom";
import { InputDialog } from "../../../libs/app-core/dialogs/InputDialog";
import { MemberDAO } from "../../dao/MemberDAO";
import CheckBox from "../../../libs/rhf-mui/ui/CheckBox";
import { His_Api } from "../../dao/His_Api";
import { FrmHisManagerParams } from "../FrmHisManager";
import UcHisTestView from "./UcHisDtoView/UcHisTestView";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { Member } from "../../dao/Member";
import dayjs from "dayjs";
import { DialogButtons } from "../../../libs/app-core/dialogs/DialogButtons";
import UcUiManager, { HisExcelDto } from "./UcHisDtoView/UcUiManager";

export type FrmSpwkToHisParams = {
  project_guid: string;
  member_guid_list: string[];
};

type Props = {};

const FrmSpwkToHis = (props: Props) => {
  //#region 讀取網址參數
  let params = useLocation().state as FrmSpwkToHisParams;
  let project_guid: string = params.project_guid;
  let member_guid_list: string[] = params.member_guid_list ?? [];
  //#endregion

  if (project_guid == null) {
    throw new Error("project_guid==null!!!");
  }
  //-------------------------------------------------------
  const ctx = useAppContext();

  /** 特作答案列表 - 不管怎麼折騰，反正最後以這個列表來轉檔 */
  const [AnsList, set_AnsList] = useState<UniAnswer[]>([]);

  /** 上述 AnsList 所有用到的特作格式定義樹狀圖，快取在這裡 */
  const [CacheBaseFormList, set_CacheBaseFormList] = useState<UniForm[]>([]);
  const [CacheSpwkFormList, set_CacheSpwkFormList] = useState<UniForm[]>([]);

  const MAX_WIDTH = "lg";
  const [AppBarTabIndex, set_AppBarTabIndex] = useState("tab_快取樹狀圖");

  /** $$$ [核心]本頁面轉檔的結果紀錄 */
  const [CacheUniFuncList, set_CacheUniFuncList] = useState<UniFunc[]>([]);

  const [CurrUniFunc, set_CurrUniFunc] = useState<UniFunc | null>(null);

  /** $$$ [核心]本頁面轉檔的結果紀錄 */
  const [InfoList, set_InfoList] = useState<SpwkToHisInfo[]>([]);

  /** 左側列表 Focus 的答案 GUID */
  const [SelectedAnswerGuid, set_SelectedAnswerGuid] = useState("");
  const [IsGovCode, set_IsGovCode] = useState<boolean>(true);
  const [IsHisCode, set_IsHisCode] = useState<boolean>(true);
  const [IsUiCode, set_IsUiCode] = useState<boolean>(true);
  /** 當前選到的左側答案 的 轉檔結果 */
  const CurrInfo: SpwkToHisInfo | undefined = InfoList.find(
    (x) => x.ANSWER_GUID === SelectedAnswerGuid
  );

  useEffect(() => {
    async function asnc_func() {
      await btn_一鍵轉換_Click();
    }

    asnc_func();
  }, [project_guid, member_guid_list]);

  //#region  要開啟哪個選單，與選單位置
  const [MenuPosition, set_MenuPosition] = useState<any>(null);
  const [MenuName, set_MenuName] = useState<any>(null);

  const OnMenuOpen = (event: React.MouseEvent, menu_strip_name: string) => {
    if (MenuPosition) {
      return;
    }
    event.preventDefault();

    set_MenuName(menu_strip_name); // 標記要開啟的 Menu

    const rect = event.currentTarget.getBoundingClientRect();
    set_MenuPosition({ top: rect.top + rect.height, left: rect.left }); // 左下角
  };

  function CloseMenu() {
    set_MenuPosition(null);
  }
  //#endregion

  return render_MasterDetail();

  function render_MasterDetail() {
    return (
      <Box style={linear_content_style}>
        {/* 外框架 */}
        <Grid {...linear_h}>
          <Grid
            {...linear_item}
            bgcolor=""
            sx={{ width: { xs: "160px", sm: "240px", xl: "360px" } }}
          >
            {/* 左側主檔 Master */}
            {render_Master()}
          </Grid>
          <Grid {...linear_item} flex={1} bgcolor="">
            {/* 中間列表 Details */}
            {render_Detail()}
          </Grid>
        </Grid>
      </Box>
    );
  }

  function render_Master() {
    /* 主檔: 左側答案選單 */
    return (
      <UcAnsList
        AnsList={AnsList}
        SelectedAnswerGuid={SelectedAnswerGuid}
        OnAnswerSelected={OnAnswerSelected}
        InfoList={InfoList}
      />
    );
  }

  function render_Detail() {
    /* 明細檔: 右側內容 */
    return (
      <>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_AppBar()}</Grid>
          <Grid {...linear_item} flex={1}>
            {/* 上方特作篩選藥丸按鈕列表 */}
            <Grid {...linear_v}>
              <UcSpwkPills
                CurrInfo={CurrInfo}
                CacheUniFuncList={CacheUniFuncList}
                CurrUniFunc={CurrUniFunc}
                OnUniFuncSelected={(sel_func) => {
                  if (sel_func.guid === CurrUniFunc?.guid) {
                    set_CurrUniFunc(null); // 點第2下是清空篩選
                  } else {
                    set_CurrUniFunc(sel_func); // 設定篩選
                  }
                }}
              />

              {render_TabControl()}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position="static" sx={{ bgcolor: R.color.app_bar }}>
          <Toolbar variant="dense">
            <AppMenuButton label={render_AppTitle()} />
            <Box sx={{ flexGrow: 1 }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
            {render_CheckBox()}
            {render_ActionButtons()}
          </Toolbar>
          {render_AppTabs()}
        </AppBar>
      </>
    );
  }

  function render_AppTitle() {
    return (
      <div>
        <Label
          variant="subtitle2"
          sx={{ p: 0, m: 0 }}
        >{`匯入院內資訊系統`}</Label>
      </div>
    );
  }

  function render_ActionButtons() {
    return (
      <div>
        <Button
          variant="contained"
          size="small"
          sx={{
            mx: 1,
            bgcolor: R.color.accent,
            ":hover": {
              bgcolor: R.color.accent_light, // theme.palette.primary.main
              color: "white",
            },
          }}
          onClick={btn_一鍵轉換_Click}
        >
          一鍵轉換
        </Button>

        <Button
          variant="contained"
          size="small"
          sx={{
            mx: 1,
            bgcolor: R.color.background,
            color: "Black",
            ":hover": {
              bgcolor: R.color.accent_dark, // theme.palette.primary.main
              color: "yellow",
            },
          }}
          onClick={btn_匯入院內_Click}
        >
          匯入院內
        </Button>
        <IconButton
          onClick={(e) => OnMenuOpen(e, "Menu分解動作")}
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
        >
          {render_Menu分解動作("Menu分解動作")}
          <Label variant="caption" sx={{ mr: 1 }}>
            {"分解動作"}
          </Label>
        </IconButton>

        <IconButton
          onClick={(e) => OnMenuOpen(e, "Menu更多")}
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
        >
          {render_Menu更多("Menu更多")}
          <MoreIcon />
        </IconButton>
      </div>
    );
  }

  function render_CheckBox() {
    return (
      <div>
        <CheckBox
          label={"問卷申報"}
          markProps={{
            checked: IsGovCode,
            onChange(event, checked) {
              set_IsGovCode(checked);
            },
            style: {
              color: "#EE7674",
            },
          }}
        />
        <CheckBox
          label={"問卷明細"}
          markProps={{
            checked: IsHisCode,
            onChange(event, checked) {
              set_IsHisCode(checked);
            },
            style: {
              color: "#EE7674",
            },
          }}
        />
        <CheckBox
          label={"問卷UI基礎"}
          markProps={{
            checked: IsUiCode,
            onChange(event, checked) {
              set_IsUiCode(checked);
            },
            style: {
              color: "#EE7674",
            },
          }}
        />
      </div>
    );
  }

  function render_AppTabs() {
    return (
      <Container>
        <AppBarTabs
          AppBarTabIndex={AppBarTabIndex}
          set_AppBarTabIndex={set_AppBarTabIndex}
        >
          <Tab label="快取樹狀圖" value={"tab_快取樹狀圖"} />
          <Tab label="中繼檔" value={"tab_中繼檔"} />
          <Tab label="基本檔" value={"tab_基本檔"} />
          <Tab label="特作行" value={"tab_特作行"} />
          <Tab label="申報行" value={"tab_申報行"} />
          <Tab label="轉檔測試" value={"tab_轉檔測試"} />
          <Tab label="轉檔格式" value={"tab_轉檔格式"} />
        </AppBarTabs>
      </Container>
    );
  }

  function render_TabControl() {
    return (
      <Box style={linear_content_style} sx={{}}>
        <TabPage tab_key={"tab_快取樹狀圖"} curr_tab={AppBarTabIndex} sx={{}}>
          <Container maxWidth={MAX_WIDTH} sx={{}}>
            {render_快取樹狀圖()}
          </Container>
        </TabPage>

        <TabPage
          tab_key={"tab_中繼檔"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_中繼檔列表()}</Box>
        </TabPage>

        <TabPage
          tab_key={"tab_基本檔"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_基本檔()}</Box>
        </TabPage>

        <TabPage
          tab_key={"tab_特作行"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_特作行()}</Box>
        </TabPage>

        <TabPage
          tab_key={"tab_申報行"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_申報行()}</Box>
        </TabPage>

        <TabPage
          tab_key={"tab_轉檔測試"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_轉檔測試()}</Box>
        </TabPage>

        <TabPage
          tab_key={"tab_轉檔格式"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_轉檔格式()}</Box>
        </TabPage>
      </Box>
    );
  }

  function OnAnswerSelected(answer_guid: string) {
    set_CurrUniFunc(null);
    set_SelectedAnswerGuid(answer_guid);
  }

  function render_快取樹狀圖() {
    return (
      <Uc快取樹狀圖
        BaseFormList={CacheBaseFormList}
        SpwkFormList={CacheSpwkFormList}
      />
    );
  }

  function render_中繼檔列表() {
    return (
      <UcSpwkMetaTableView CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />
    );
  }

  function render_基本檔() {
    return <UcHisBasicView CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />;
  }

  function render_特作行() {
    return <UcHisRowView CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />;
  }

  function render_申報行() {
    return <UcGovRowView CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />;
  }

  function render_轉檔格式() {
    return (
      <UcHisDtoView
        CurrInfo={CurrInfo}
        CurrUniFunc={CurrUniFunc}
        infoList={InfoList}
      />
    );
  }

  function render_轉檔測試() {
    return (
      <UcHisTestView
        CurrInfo={CurrInfo}
        CurrUniFunc={CurrUniFunc}
        infoList={InfoList}
      />
    );
  }

  async function btn_一鍵轉換_Click() {
    /* 清空篩選 */
    set_CurrUniFunc(null);

    /* 先快取 Func List 備用 */
    const func_list = await UniFuncDAO.Select();
    set_CacheUniFuncList(func_list);

    //---------------------------------------------------------------------------

    // 1. btn_載入Answers_Click -----------------------------------------------------
    let ans_list: UniAnswer[] = await LoadAnswers(
      project_guid,
      member_guid_list
    );

    // 2. btn_快取樹狀圖_Click -----------------------------------------------------
    let { base_form_guid_list, spwk_form_guid_list } =
      取得Base與Spwk的FormGuidList(ans_list);

    let { base_form_list, spwk_form_list } =
      await ExportManager.GetForms_AndFillTree_Async(
        base_form_guid_list,
        spwk_form_guid_list
      );

    // 3. btn_轉為中繼檔_Click -----------------------------------------------------
    let info_list: SpwkToHisInfo[] = 轉換為中繼檔(
      ans_list,
      base_form_list,
      spwk_form_list
    );

    // 4. btn_轉為匯入HIS格式_Click  -----------------------------------------------------
    轉為匯入院內HIS格式(info_list);
    //5.轉為UI格式_Click------------------------------------------------------------
    await 轉為UI格式(info_list);
    //----------------------------------------------------------------------
    set_SelectedAnswerGuid(""); // 清空左側選擇
    set_AnsList(ans_list);

    if (ans_list.length !== 0) {
      set_SelectedAnswerGuid(ans_list[0].guid);
    }

    set_CacheBaseFormList(base_form_list);
    set_CacheSpwkFormList(spwk_form_list);
    set_InfoList([...info_list]); // 改為新物件加入

    set_AppBarTabIndex("tab_轉檔格式");

    Toast.Show(ctx, "一鍵轉換完成，請點選左方");
  }
  async function btn_匯入院內_Click() {
    MessageDialog.Show(ctx, "", "確定匯入院內?", {
      ...DialogButtons.OKCancel,
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          yesClick();
        } else {
          Toast.Show(ctx, "取消匯入");
        }
      },
    });
  }

  async function yesClick() {
    let count = 0;
    const MaxBatch = 100;
    const totalCount = InfoList.length;
    const batchCountThreshold = 100; // 每100筆顯示提示訊息
    let errorMemberList = [];
    let batchCount = 0;
    do {
      for (let i = count; i < count + MaxBatch && i < totalCount; i++) {
        const Info = InfoList[i];
        let member = await MemberDAO.WS_FetchByGuid(Info.Ans.member_guid);
        console.log(member.member_code);
        if (dayjs(member.rec_dt).year() === 2999) {
          Info.HisDto_ErrorList.push(
            `請先幫${member.member_name}取得實際健檢日`
          );
          errorMemberList.push(member.member_name);
        } else {
          if (Info.HisDto != null) {
            await MemberDAO.UpdateDrComment(member, "dr_comment", Info.HisDto);
            let re = await His_Api.上傳Async(
              Info.HisDto,
              member,
              IsGovCode,
              IsUiCode,
              IsHisCode
            );
            if (re !== "1") {
              Info.HisDto_ErrorList.push(`${member.member_name}匯入資料失敗`);
              errorMemberList.push(member.member_name);
            }
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }
        batchCount++;
        if (batchCount % batchCountThreshold === 0 || i === totalCount - 1) {
          Toast.Show(ctx, `已執行完成 ${batchCount} 筆`);
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 2000));
      count += MaxBatch;
    } while (count < totalCount);
    alert("已執行完成");
    if (errorMemberList.length !== 0) {
      alert(`受檢者${errorMemberList}資料有誤`);
    }
  }

  async function btn_載入Answers_Click() {
    /* 清空篩選 */
    set_CurrUniFunc(null);

    /* 先快取 Func List 備用 */
    const func_list = await UniFuncDAO.Select();
    set_CacheUniFuncList(func_list);
    //-------------------------------------------------------

    let ans_list: UniAnswer[] = await LoadAnswers(
      project_guid,
      member_guid_list
    );

    //-------------------------------------------------------
    set_SelectedAnswerGuid(""); // 清空左側選擇
    set_AnsList(ans_list);

    sth_log(`已載入答案 x${ans_list.length}`);
    Toast.Show(ctx, "已載入答案");
  }

  async function btn_快取樹狀圖_Click() {
    let { base_form_guid_list, spwk_form_guid_list } =
      取得Base與Spwk的FormGuidList(AnsList);

    let { base_form_list, spwk_form_list } =
      await ExportManager.GetForms_AndFillTree_Async(
        base_form_guid_list,
        spwk_form_guid_list
      );

    set_CacheBaseFormList(base_form_list);
    set_CacheSpwkFormList(spwk_form_list);

    sth_log(
      `已準備好樹狀圖 base=${base_form_list.length}, spwk=${spwk_form_list.length}`
    );
    Toast.Show(ctx, "已準備好樹狀圖");
  }

  async function btn_轉為中繼檔_Click() {
    let info_list: SpwkToHisInfo[] = 轉換為中繼檔(
      AnsList,
      CacheBaseFormList,
      CacheSpwkFormList
    );

    set_InfoList(info_list);
    Toast.Show(ctx, "已載入Info.");
  }

  async function btn_轉為匯入HIS格式_Click() {
    轉為匯入院內HIS格式(InfoList);

    set_InfoList([...InfoList]); // 改為新物件加入

    Toast.Show(ctx, "轉為匯入HIS格式");
  }
  async function btn_轉為UI格式_Click() {
    await 轉為UI格式(InfoList);
  }

  function btn_說明_Click() {
    InputDialog.Show(ctx, "", "請輸入驗證碼", "", {
      onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          if (e.Data === "5229") {
            ctx.Navigate(ROUTE_spwk_to_his_rule.url);
          } else {
            Toast.Show(ctx, "驗證失敗!");
          }
        }
      },
    });
  }

  async function btn_實際健檢日_Click(InfoList: SpwkToHisInfo[]) {
    let count = 0;
    const MaxBatch = 100;
    const totalCount = InfoList.length;
    let errorMemberList: string[] = [];
    MessageDialog.Show(ctx, "", "確定更新並實際健檢日?", {
      ...DialogButtons.OKCancel,
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          do {
            for (let i = count; i < count + MaxBatch && i < totalCount; i++) {
              const Info = InfoList[i];
              let member = await MemberDAO.WS_FetchByGuid(Info.Ans.member_guid);
              console.log(member.member_code);
              member.rec_dt = await His_Api.GetRealRecDt(member.member_code);
              if (member.rec_dt === "") {
                Info.HisDto_ErrorList.push(
                  ` ${member.member_name}並無正確取得實際健檢日`
                );
                errorMemberList.push(member.member_name);
              } else {
                await MemberDAO.Update_RecDt(member);
              }
            }
            const batchCount = Math.min(MaxBatch, totalCount - count);
            Toast.Show(ctx, `已執行完成 ${batchCount} 筆`);
            await new Promise((resolve) => setTimeout(resolve, 2000));
            count += MaxBatch;
          } while (count < totalCount);
          alert("已執行完成");
          Toast.ShowScuccess(ctx, "獲取成功");
          if (errorMemberList.length !== 0) {
            alert(`受檢者${errorMemberList}資料有誤`);
          }
        } else {
          Toast.Show(ctx, "取消獲取");
        }
        await new Promise((resolve) => setTimeout(resolve, 3000));
        window.location.reload();
      },
    });
  }
  interface CommentData {
    自覺症狀: string;
    既往病歷: string;
  }
  async function btn_測試_Click() {
    let count = 0;
    const MaxBatch = 100;
    const totalCount = InfoList.length;
    const batchCountThreshold = 100; // 每100筆顯示提示訊息
    let batchCount = 0;
    do {
      for (let i = count; i < count + MaxBatch && i < totalCount; i++) {
        const Info = InfoList[i];
        let member = await MemberDAO.WS_FetchByGuid(Info.Ans.member_guid);
        let member_code = member.member_code;
        let re: CommentData = await MemberDAO.WS_GetDrComment(member_code);
        console.log(re);
        batchCount++;
        if (batchCount % batchCountThreshold === 0 || i === totalCount - 1) {
          Toast.Show(ctx, `已執行完成 ${batchCount} 筆`);
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 2000));
      count += MaxBatch;
    } while (count < totalCount);
    alert("已執行完成");
  }

  function render_Menu分解動作(menu_name: string) {
    return (
      <Menu
        open={!!MenuPosition && MenuName === menu_name}
        onClose={() => set_MenuPosition(null)}
        anchorReference="anchorPosition"
        anchorPosition={MenuPosition}
      >
        <MenuItem
          onClick={() => {
            btn_載入Answers_Click();
            CloseMenu();
          }}
        >
          <ListItemText>1.載入答卷</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_快取樹狀圖_Click();
            CloseMenu();
          }}
        >
          <ListItemText>2.快取樹狀圖</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_轉為中繼檔_Click();
            CloseMenu();
          }}
        >
          <ListItemText>3.轉為中繼檔</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_轉為匯入HIS格式_Click();
            CloseMenu();
          }}
        >
          <ListItemText>4.轉為匯入HIS格式</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_轉為UI格式_Click();
            CloseMenu();
          }}
        >
          <ListItemText>5.轉為匯入UI格式</ListItemText>
        </MenuItem>
      </Menu>
    );
  }

  function render_Menu更多(menu_name: string) {
    function btn_轉入匯入院內_Click() {
      InputDialog.Show(ctx, "", "請輸入驗證碼", "", {
        onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (e.Data === "9595") {
              let args: FrmHisManagerParams = {
                InfoList: InfoList,
              };
              ctx.Navigate(ROUTE_his_manager.url, { state: args });
            } else {
              Toast.Show(ctx, "驗證失敗!");
            }
          }
        },
      });
    }

    return (
      <Menu
        open={!!MenuPosition && MenuName === menu_name}
        onClose={() => set_MenuPosition(null)}
        anchorReference="anchorPosition"
        anchorPosition={MenuPosition}
      >
        <MenuItem
          onClick={() => {
            btn_說明_Click();
            CloseMenu();
          }}
          sx={{ minWidth: "200px" }}
        >
          <HelpIcon fontSize="small" sx={{ mr: 1 }} />
          <ListItemText>說明</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_轉入匯入院內_Click();
            CloseMenu();
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>匯入院內</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_實際健檢日_Click(InfoList);
            CloseMenu();
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>實際健檢日</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_轉為UI格式_Click();
            CloseMenu();
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>轉為UI</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            btn_測試_Click();
            CloseMenu();
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>Test</ListItemText>
        </MenuItem>
      </Menu>
    );
  }
};

export default FrmSpwkToHis;

function 轉為匯入院內HIS格式(InfoList: SpwkToHisInfo[]) {
  for (const info of InfoList) {
    if (
      info.get_ExportBundle_FinishStatus() === FinishStatus.Error ||
      info.ExportBundle == null
    ) {
      info.HisDto_ErrorList.push(
        "缺少 ExportBundle ， 先前 xls 轉檔沒有成功，無法繼續轉換為 API 格式!!!"
      );
      continue;
    }

    let his_dto_rslt: HisDtoResult = HisDtoManager.ConvertFromExportBundle(
      info.ExportBundle
    );

    info.HisDto = his_dto_rslt.HisDto;
    info.HisDto_WarningList = info.HisDto_WarningList.concat(
      his_dto_rslt.WarningList
    );
    info.HisDto_ErrorList = info.HisDto_ErrorList.concat(
      his_dto_rslt.ErrorList
    );
  }
}
//Yao Todo render或json狀態先後順序調整
async function 轉為UI格式(InfoList: SpwkToHisInfo[]) {
  for (const info of InfoList) {
    let excelList: HisExcelDto[] = [];
    const memberList: Member[] = [];
    const member: Member = await MemberDAO.WS_FetchByGuid(info.Ans.member_guid);
    if (
      info.get_ExportBundle_FinishStatus() === FinishStatus.Error ||
      info.ExportBundle == null
    ) {
      info.HisDto_ErrorList.push(
        "缺少 ExportBundle ， 先前 xls 轉檔沒有成功，無法繼續轉換為 API 格式!!!"
      );
      continue;
    }

    let all_basic_list = info.ExportBundle.AllHisBasicList;
    let form_list: string[] = [];

    for (const basic of all_basic_list) {
      /** 處理 這個受檢者 的 單一特作 */
      let 作業編號 = basic.作業編號;
      form_list.push(作業編號);
    }
    memberList.push(member);
    const ucUiManager = UcUiManager();
    let result = ucUiManager.fillValue(member, excelList, info);
    if (result !== undefined) {
      // excelList = result
    }
    let Ui = ucUiManager.getUiInfo(excelList, memberList, info);
    if (Ui.length === 1) {
      if (info.HisDto) {
        info.HisDto.問卷UI基礎 = Ui[0];
      }
    }
  }
}
function 轉換為中繼檔(
  AnsList: UniAnswer[],
  CacheBaseFormList: UniForm[],
  CacheSpwkFormList: UniForm[]
) {
  let info_list: SpwkToHisInfo[] = [];

  for (const ans of AnsList) {
    let info = new SpwkToHisInfo(ans);
    info_list.push(info);

    try {
      const relate_spwk_form_guids = ans.getSpwkFormGuidList(); // 此合併問卷包含哪些特作

      const find_base_form = CacheBaseFormList.find(
        (x) => x.guid === ans.base_form_guid
      ); // 找出通用題目
      const relate_spwk_forms = CacheSpwkFormList.filter((x) =>
        relate_spwk_form_guids.includes(x.guid)
      );

      const single_export_bundle: ExportBundle | null =
        ExportManager.RunExportOneAnswer(
          ans,
          find_base_form,
          relate_spwk_forms
        );

      info.ExportBundle = single_export_bundle;
    } catch (ex: any) {
      info.ExportBundle_ErrorList.push((ex as Error).message);
    }
  }

  return info_list;
}

async function LoadAnswers(project_guid: string, member_guid_list: string[]) {
  // TODO 改為外部傳入參數

  let project_answer_list = await UniAnswerDAO.Select_指定場次的特作答案列表(
    project_guid
  );
  let ans_list: UniAnswer[] = [];

  for (const member_guid of member_guid_list) {
    let finds = project_answer_list.filter(
      (x) => x.member_guid === member_guid
    );
    if (finds.length !== 1) {
      throw new_ErrorAlert(
        "46481368 預期應該要有剛好一筆 Answer !!! member_guid: " + member_guid
      );
    }

    ans_list.push(finds[0]);
  }
  return ans_list;
}

function 取得Base與Spwk的FormGuidList(AnsList: UniAnswer[]): {
  base_form_guid_list: string[];
  spwk_form_guid_list: string[];
} {
  let base_form_guid_list: string[] = [];
  let spwk_form_guid_list: string[] = [];

  for (const ans of AnsList) {
    base_form_guid_list.push(ans.base_form_guid);
    spwk_form_guid_list = spwk_form_guid_list.concat(ans.getSpwkFormGuidList());
  }

  // 不重複的
  base_form_guid_list = base_form_guid_list.filter(
    (value, index, self) => self.indexOf(value) === index
  );
  spwk_form_guid_list = spwk_form_guid_list.filter(
    (value, index, self) => self.indexOf(value) === index
  );

  return { base_form_guid_list, spwk_form_guid_list };
}
